export default "__VITE_ASSET__8ed5c8ec__"